import React, {useEffect} from 'react';
import {Route, Routes} from 'react-router-dom';
import SearchFlight from "./flights/SearchFlight";
import ListFlightPage from "./flights/ListFlightPage";
import PassengerListPage from "./flights/PassengerListPage";
import NotFoundPage from "./NotFoundPage";
import { useLocation } from 'react-router-dom';
import {getUserTokenFn, getUserToken, setUserToken} from "../helper/commonFunction";
import {useDispatch, useSelector} from "react-redux";
import {getUserData, setAgentActiveCurrency} from "../redux/slice/userSlice";
import {useNavigate} from "react-router";
import SearchHotels from './hotels/search/SearchHotels';
import ListHotels from './hotels/list/ListHotels';
import HotelDetails from './hotels/details';
import ExcursionList from './excursion/list';
import ExcursionDetails from './excursion/details';
import ExcursionCheckout from './excursion/checkout';
import ExcursionCities from './excursion/cities';
import HotelCheckout from './hotels/checkout';
import ExcursionSearch from './excursion/search';
import { errorRoutes } from "./errorRoutes";
import PhotoEditorPage from "./photo-editor/PhotoEditorPage";
import { useAutoLogout } from "../hooks/useAutoLogout";


function MainRoute() {
    const location = useLocation();
    const token = getUserTokenFn(location.search);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userAgentData,userAgentLoader,userKyc } = useSelector((state) => state.userData);

    // Auto-logout after 60 min of inactivity. Only tracks while authenticated
    // (a user token is present); the hook itself no-ops when disabled.
    useAutoLogout(!!getUserToken() && userAgentData?.user_data?.isLogin !== false);

    useEffect(() => {
        if(token){
            setUserToken(token);
            dispatch(getUserData(token));
            const params = new URLSearchParams(location.search);
            if(params?.has('token')){
                params.delete('token');
                const newSearch = params.toString();
                const newPath = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;
                navigate(newPath, { replace: true });
            }
        }else{
            let token = getUserToken();
            if(token){
                dispatch(getUserData(token));
            }else{
                window.location.href = process.env.wordpressApiEndPoint;
            }
        }
    },[token])

    useEffect(() => {
        if(!userAgentLoader){
            if(!userAgentData?.user_data?.isLogin || userKyc === false){
                window.location.href = process.env.wordpressApiEndPoint;
            }
            if(location.pathname.startsWith('/flight') && !userAgentData?.allowed_user){
                window.location.href = process.env.wordpressApiEndPoint;
            }
            if(location.pathname.startsWith('/excursion') && !userAgentData?.allowed_excursion_user){
                window.location.href = process.env.wordpressApiEndPoint;
            }
        }

    },[userAgentLoader, location.pathname])



    return (
        (!userAgentLoader) ?
        <Routes>
            <Route path="/hotels/checkout/:id" element={<HotelCheckout/>}/>
            <Route path="/hotels/details/:id" element={<HotelDetails/>}/>
            <Route path="/hotels/list" element={<ListHotels/>}/>
            <Route path="/hotels/search" element={<SearchHotels/>}/>

            <Route path="/excursion/search" element={<ExcursionSearch/>}/>
            <Route path="/excursion/checkout" element={<ExcursionCheckout/>}/>
            <Route path="/excursion/details/:id" element={<ExcursionDetails/>}/>
            <Route path="/excursion/list" element={<ExcursionList/>}/>
            <Route path="/excursion/cities" element={<ExcursionCities/>}/>

            <Route path="/flight/search" element={<SearchFlight/>}/>
            <Route path="/flight/list" element={<ListFlightPage/>}/>
            <Route path="/flight/booking" element={<PassengerListPage/>}/>

            <Route path="/photo-editor" element={<PhotoEditorPage/>}/>

            {errorRoutes}
            {/* 404 Fallback Route */}
            <Route path="*" element={<NotFoundPage/>}/>
        </Routes> : <div className='hw-main--loaderM' />
    );
}

export default MainRoute;
